import { Model } from '@vuex-orm/core'

import { Channel } from './Channel'

class FixedJournalList extends Model {
  static entity = 'fixedJournalLists'
  static primaryKey = ['channel_id', 'id']

  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      name: this.attr(null),
      order: this.attr(null),
      modified_at: this.attr(null),
      color: this.attr(null),
      channel: this.belongsTo(Channel, 'channel_id'),
      fixed_journals: this.hasMany(FixedJournal, 'fixed_journal_list_id')
    }
  }
}

class FixedJournal extends Model {
  static entity = 'fixedJournals'
  static primaryKey = ['channel_id', 'fixed_journal_list_id', 'id']

  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      name: this.attr(null),
      order: this.attr(null),
      fixed_journal_list_id: this.attr(null),
      fixed_journal_list: this.belongsTo(FixedJournalList, 'fixed_journal_list_id')
    }
  }
}

export {
  FixedJournalList,
  FixedJournal,
}
